import './NonStandardLevelNs.css';

import React, { useEffect, useState } from 'react';
import useNonStandardLevelNs from '../../../b2b-frameworks/hooks/useNonStandardLevelNs';
import B2BElementsExplorerInMemory from '../../../b2b-common/B2BElementsExplorerInMemory';
import { generateClassName } from '../../../b2b-common/helpers';
import NonStandardLevelNsCard from './NonStandardLevelNsCard';
import { isEqual } from 'lodash';

const NonStandardLevelNs = ({ frameworkSuite, frameworkId, selectedNonStandardLevelNs, onUpdate, className = null }) => {
    const nonStandardLevelNs  = useNonStandardLevelNs(frameworkSuite, [frameworkId]);
    const [currentSelectedNonStandardLevelNs, setCurrentSelectedNonStandardLevelNs] = useState(selectedNonStandardLevelNs);

    useEffect(() => {
        if (selectedNonStandardLevelNs && !isEqual(selectedNonStandardLevelNs, currentSelectedNonStandardLevelNs)) {
            setCurrentSelectedNonStandardLevelNs(selectedNonStandardLevelNs);
        }
    } , [selectedNonStandardLevelNs]);

    if (!nonStandardLevelNs || !nonStandardLevelNs[0].nonStandardLevelNs) return null;

    const handleSelectUnselectNonStandardLevelN = (nonStandardLevelN) => {
        const index = currentSelectedNonStandardLevelNs
            .findIndex(item => item.levelN_ItemId === nonStandardLevelN.levelN_ItemId);
        if (index >= 0) {
            const newSelectedNonStandardLevelNs = [...currentSelectedNonStandardLevelNs];
            newSelectedNonStandardLevelNs.splice(index, 1);
            setCurrentSelectedNonStandardLevelNs(newSelectedNonStandardLevelNs);
            onUpdate(newSelectedNonStandardLevelNs);
        } else {
            const updatedSelectedNonStandardLevelNs = [...currentSelectedNonStandardLevelNs,
                {
                    frameworkId: frameworkId,
                    levelN_ItemId: nonStandardLevelN.levelN_ItemId,
                }
            ];
            setCurrentSelectedNonStandardLevelNs(updatedSelectedNonStandardLevelNs);
            onUpdate(updatedSelectedNonStandardLevelNs);
        }
    };

    return (
        <B2BElementsExplorerInMemory
            elementsData={{ content: nonStandardLevelNs[0].nonStandardLevelNs }}
            className={generateClassName('non-standard-level-ns','', className)}
            ElementComponent={NonStandardLevelNsCard}
            elementComponentPropName={'nonStandardLevelN'}
            otherComponentProps={{
                frameworkSuite,
                frameworkId,
                selectedNonStandardLevelNs: currentSelectedNonStandardLevelNs,
            }}
            elementComponentHandlers={{
                onClick: handleSelectUnselectNonStandardLevelN,
            }}
            numRows={nonStandardLevelNs[0].nonStandardLevelNs.length}
        />

    );
}

export default NonStandardLevelNs;